import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {
  padding: "10px",
  display: "flex",
  border: `1px solid ${colors.peach.darker}`,
  borderRadius: 8,
};

const containerApproachingLimit: CSSProperties = {
  ...container,
  background: helpers.opacity(colors.peach.darker, 0.2),
  color: colors.peach.darker,
};

const containerOverLimit: CSSProperties = {
  ...container,
  background: helpers.opacity(colors.peach.darker, 0.2),
  color: colors.peach.darker,
};

const right: CSSProperties = {
  margin: "4px 0 0 10px",
};

const header: CSSProperties = {
  fontSize: 14,
  fontWeight: "bold",
  marginBottom: 5,
};

const content: CSSProperties = {
  fontSize: 12,
  lineHeight: 1.5,
  marginBottom: 10,
};

const actions: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

const button: CSSProperties = {
  fontSize: 12,
  marginRight: 8,
  padding: "5px 10px",
};

const buttonApproachingLimit: CSSProperties = {
  ...button,
  color: colors.peach.darker,
  borderColor: colors.peach.darker,
};

const buttonOverLimit: CSSProperties = {
  ...button,
  color: colors.peach.darker,
  borderColor: colors.peach.darker,
};

const contactContainer: CSSProperties = {
  fontSize: 12,
};

const contactLink: CSSProperties = {
  color: colors.peach.darker,
  borderColor: colors.peach.darker,
};

export const styles = {
  containerApproachingLimit,
  containerOverLimit,
  right,
  header,
  content,
  actions,
  buttonApproachingLimit,
  buttonOverLimit,
  contactContainer,
  contactLink,
};
